import Descriptions from "@/components/Product/Descriptions";
import ProductsBy from "@/components/Helpers/ProductsBy";
import AddNewRate from "@/components/Product/AddNewRate";
import Album from "@/components/Product/Album";
import Detail from "@/components/Product/Detail";
import Rating from "@/components/Product/Rating";
import { AllBranches } from "@/components/Product/Branches";
import { useContext, useEffect, useState } from "react";
import ProductsBundle from "@/components/Product/ProductsBundle2";
import FreeProduct from "@/components/Product/FreeProduct";
import ProductBreadCrumb from "@/components/Product/ProductBreadCrumb";
import SEO from "@/components/seo";
import { useRouter } from "next/router";
import FlixMedia from "@/components/Product/FlixMedia";
import useSWR, { useSWRConfig, mutate } from "swr";
import {
  getCurrentDateTime,
  handleSetAndFetchProducts,
  product_meta_desc,
  selectedAtteributes,
} from "@/utils/product";
import { productRatings } from "@/services/product/product";
import { STORE_LOCATOR } from "@/services/product";
import {
  getActivePdpDetails,
  getProductBySku,
} from "@/services/elasticsearch/getProduct";
import {
  getAmastyProductsBySkus,
  getProductsBySkuV2,
} from "@/services/elasticsearch/getProducts";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { event_select_promotion, event_view_promotion } from "@/utils/gtm";
import AWSPersonalizeCtx from "@/contexts/aws-personalize/aws-personalize-context";
import useGetAwsPersonalizeProducts from "@/hooks/useGetAwsPersonalizeProducts";
import {
  CUSTOMER_WHO_VIEWED_ALSO_VIEWED,
  FREQUENTLY_BOUGHT_TOGETHER,
} from "@/services/global/aws-personalize";
import { IS_TYPESENSE_GLOBAL } from "@/utils/typesense/config";
import { tssGetProductBySkuWithPreset } from "@/services/typesense/getProductBySku";
import useSWRMutation from "swr/mutation";
import { getCookies } from "cookies-next";
import Cookies from "js-cookie";
import TTLStreamContent from "@/components/Product/ttl-stream";
import { handshakeCookieName } from "@/constants";
import { localeHandShake } from "@/services/token/handshake";

const ProductDetailsPage = ({ product: productData, pdp_details }) => {
  const [product, setProduct] = useState(productData);
  const { t } = useTranslation("product");
  const { locale, asPath, query } = useRouter();
  const { handshake } = getCookies();
  const [addRate, setAddRate] = useState(false);
  const [city, setCity] = useState("");
  const [showBranches, setShowBranches] = useState(false);
  const [ratings, setRatings] = useState();
  const [store, setStore] = useState();
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [sameBrandProducts, setSameBrandProducts] = useState();
  const region_id = Cookies.get("region_id");

  useEffect(() => {
    setProduct(productData);
  }, [productData]);

  const { cache } = useSWRConfig();
  const currentDateTime = getCurrentDateTime();

  // integration with aws personalize
  const { isDirectConnectToAWS, sendPersonalizeEvent } =
    useContext(AWSPersonalizeCtx);

  useEffect(() => {
    if (
      isDirectConnectToAWS &&
      process.env.NEXT_PUBLIC_NODE_ENV === "production" &&
      !product?.sku?.includes("___")
    ) {
      sendPersonalizeEvent([
        {
          eventType: "View",
          sentAt: Date.now(),
          itemId: product?.sku,
        },
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDirectConnectToAWS, product.sku]);

  // get Frequently Bought Together Products from aws personalize
  const { products: frequentlyBoughtTogetherProducts } =
    useGetAwsPersonalizeProducts(FREQUENTLY_BOUGHT_TOGETHER, {
      itemId: product.sku,
    });

  // get Also Viewed Products  from aws personalize
  const { products: alsoViewedProducts } = useGetAwsPersonalizeProducts(
    CUSTOMER_WHO_VIEWED_ALSO_VIEWED,
    {
      itemId: product.sku,
    }
  );

  const regionId =
    region_id && region_id != "NaN" && region_id != "undefined"
      ? region_id
      : "1101";



  // Checker of Parent ID
  const checkPArentID = (indexOfOffer) => {
    let existParentId = product?.bundle_discount_products[
      indexOfOffer
    ]?.parent_ids.find((parentIDD) => parentIDD == product?.entity_id);

    if (existParentId) {
      return true;
    } else {
      return false;
    }
  };
  const cacheKey = `fetch-all-products-in-PDP-${locale}-${asPath}-${product?.sku}-${regionId}`;

  const cachedPDPProducts = cache.get(cacheKey);

  // fetch all products
  const { trigger: refetchAllProducts } = useSWRMutation(
    cacheKey,
    async () => {
      const relatedRes =
        product?.custom_related_products?.length > 0
          ? null
          : await getAmastyProductsBySkus(
              handshake,
              product?.sku,
              "product_into_related"
            );
      const up_sell_Res =
        product?.up_sell_products?.length > 0
          ? null
          : await getAmastyProductsBySkus(
              handshake,
              product?.sku,
              "product_into_upsell"
            );

      console.log("relatedRes", { relatedRes, up_sell_Res });
      const upSaleSkus =
        product?.up_sell_products?.length === 0 &&
        Object.values(up_sell_Res?.data?.data?.at(0))?.at(0)?.upsell?.length ===
          0
          ? []
          : product?.up_sell_products?.length > 0
          ? product?.up_sell_products
          : Object.values(up_sell_Res?.data?.data?.at(0) ?? {})?.at(0)
              ?.upsell ?? [];

      const relatedSkus =
        product?.custom_related_products?.length === 0 &&
        Object.values(relatedRes?.data?.data?.at(0))?.at(0)?.related?.length ===
          0
          ? []
          : product?.custom_related_products?.length > 0
          ? product?.custom_related_products
          : Object.values(relatedRes?.data?.data?.at(0) ?? {})?.at(0)
              ?.related ?? [];

      const allProductsSkusObj = {
        upSale: upSaleSkus,
        related: relatedSkus,
      };

      const allSkus = [
        ...allProductsSkusObj?.upSale,
        ...allProductsSkusObj?.related,
      ];

      return allSkus?.length === 0
        ? null
        : {
            ...(await getProductsBySkuV2(
              allSkus,
              handshake,
              selectedAtteributes
            )),
            allProductsSkusObj,
          };
    },
    {
      onSuccess: (data) => {
        // Manually update the cache with the fetched data
        mutate(cacheKey, data, false); // false means don't revalidate, just update the cache
      },
    }
  );

  useEffect(() => {
    const handleFetchAndSetProducts = async () => {
      const cachedData = await mutate(cacheKey);
      const cachedProducts = cachedData?.data;
      const cachedRelatedUpSaleSkus = cachedData?.allProductsSkusObj;

      if (cachedProducts?.length) {
        handleSetAndFetchProducts(
          cachedProducts,
          cachedRelatedUpSaleSkus,
          setSameBrandProducts,
          setRelatedProducts
        );
      } else {
        const res = await refetchAllProducts();

        if (res?.data?.length) {
          handleSetAndFetchProducts(
            res?.data,
            res?.allProductsSkusObj,
            setSameBrandProducts,
            setRelatedProducts
          );
        }
      }
    };
    handleFetchAndSetProducts();
  }, [
    cachedPDPProducts?.data?.data,
    cachedPDPProducts?.data?.relatedUpSaleSkus,
    refetchAllProducts,
    cacheKey,
  ]);

  // fetch product ratings
  useSWR(
    () =>
      productData?.sku
        ? `productRatings-${productData?.sku}-${regionId}`
        : null,
    () => productRatings(handshake, productData?.sku),
    {
      revalidateOnMount: 30 * 60 * 1000,
      revalidateOnFocus: false,
      onSuccess: ({ data }) => {
        setRatings(data?.data);
      },
    }
  );

  // fetch store locator by product
  const {} = useSWR(
    () => `Store-locator-${productData?.entity_id}-${regionId}`,
    () => (productData?.entity_id ? STORE_LOCATOR(productData?.entity_id) : {}),
    {
      revalidateOnMount: 30 * 60 * 1000,
      revalidateOnFocus: false,
      onSuccess: ({ data }) => {
        setStore(data?.data?.data);
      },
    }
  );

  // GTM
  useEffect(() => {
    const item = product;
    const subset = (({
      name,
      sku,
      _category_,
      prices_with_tax,
      option_text_brand,
      stock,
    }) => ({
      item_name: Array.isArray(name) ? name?.at(0) : name,
      item_id: sku,
      item_category: _category_?.main_category?.name,
      price: (+prices_with_tax?.price || +"")?.toFixed(2),
      item_brand: option_text_brand?.[0],
      quantity: stock?.qty,
      discount: null,
    }))(item);

    query.event == "select_promotion" &&
      event_select_promotion(null, null, query?.promotion_id, null, "SAR", [
        subset,
      ]);
    query.gtm &&
      event_view_promotion(null, null, query?.promotion_id, null, "SAR", [
        subset,
      ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product]);

  // End of GTM
  const productScheema = {
    "@context": "https://schema.org/",
    "@type": "Product",
    name: product?.name || "",
    image: product?._media_?.image?.at(0)?.image || "",
    description: product_meta_desc(product?.name, locale),
    brand: {
      "@type": "Brand",
      name: product?.option_text_brand?.at(0) || "",
    },
    offers: {
      "@type": "Offer",
      url: `"https://www.almanea.sa/${locale === "en" ? "en/" : ""}product/${
        productData?.rewrite_url || ""
      }`,
      priceCurrency: "SAR",
      price: (+product?.prices_with_tax?.price || +"")?.toFixed(2),
      priceValidUntil: product?.prices_with_tax?.discounted_price_to || "",
      availability: `https://schema.org/${
        product["1101"]?.value ? "InStock" : "OutOfStock"
      }`,
      itemCondition: "https://schema.org/NewCondition",
    },
  };
  useEffect(() => {
    if (
      typeof window != undefined &&
      document.querySelector(".yarl__slide_image")
    ) {
      document.querySelector(".yarl__slide_image").style.minWidth = "1200px";
      document.querySelector(".yarl__slide_image").style.minHeight = "1200px";
    }
  }, []);
  return (
    <>
      <SEO
        title={productData?.name || ""}
        description={product_meta_desc(productData?.name, locale)}
        image={productData?.image}
        pathname={"/product/" + productData?.rewrite_url}
      >
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(productScheema, null, 2),
          }}
        />
        <link
          rel="canonical"
          href={`${process.env.NEXT_PUBLIC_WEBSITE_URL}${
            locale === "ar" ? "/product/" : "/en/product/"
          }${productData?.rewrite_url === "/" ? "" : productData?.rewrite_url}`}
        />
      </SEO>
      <section>
        <ProductBreadCrumb product={product} />
        <div className="w-[80%] max-[570px]:w-[98%] mx-auto my-5 max-md:my-2">
          <div className="grid grid-cols-12 gap-4">
            <Album images={product?._media_?.image} product={product} />
            <Detail
              product={product}
              relatedProducts={relatedProducts}
              ratings={ratings}
              pdp_details={pdp_details}
              setShowBranches={setShowBranches}
              store={store}
              city={city}
              setCity={setCity}
              t={t}
            />
          </div>

          {product?.free_gifts?.length > 0 ? (
            <FreeProduct items={product?.free_gifts} />
          ) : null}

          {product?.bundle_discount_products?.length > 0 &&
            product?.bundle_discount_products?.map((bundle, index) => {
              let checkerOfParentId = checkPArentID(index);
              return (
                <>
                  {checkerOfParentId &&
                    currentDateTime <
                      product?.bundle_discount_products[index]?.date_to &&
                    currentDateTime >
                      product?.bundle_discount_products[index]?.date_from && (
                      <ProductsBundle
                        {...{ product: product, bundle, relatedProducts, t }}
                      />
                    )}
                </>
              );
            })}

          <Descriptions
            description={product?.short_description}
            attributes={product?.product_attributes}
            returnPolicy={product?.return_policy}
            t={t}
          />
          <div id="flix-minisite" />
          <div id="flix-inpage" />
          <FlixMedia product={product} />
          <TTLStreamContent
            {...{
              sku: product?.sku,
              brand: product?.option_text_brand?.at(0),
              locale,
            }}
          />
          <Rating {...{ t, setAddRate, ratings }} />
        </div>

        {relatedProducts && relatedProducts?.length ? (
          <ProductsBy
            products={relatedProducts}
            title={t("RelatedProducts")}
            show={false}
            noOutOfStockProducts={true}
            showBackordersAnyway={true}
          />
        ) : null}
        {sameBrandProducts && sameBrandProducts?.length ? (
          <ProductsBy
            products={sameBrandProducts}
            title={t("SameBrandProducts")}
            show={false}
            noOutOfStockProducts={true}
            showBackordersAnyway={true}
          />
        ) : null}
        {frequentlyBoughtTogetherProducts &&
        frequentlyBoughtTogetherProducts?.length ? (
          <ProductsBy
            products={frequentlyBoughtTogetherProducts}
            title={t("Frequently Bought Together Products")}
            show={false}
            noOutOfStockProducts={true}
            showBackordersAnyway={true}
          />
        ) : null}

        {alsoViewedProducts && alsoViewedProducts?.length ? (
          <ProductsBy
            products={alsoViewedProducts}
            title={t("Customer Who Viewed This Product Also Viewed")}
            show={false}
            noOutOfStockProducts={true}
            showBackordersAnyway={true}
          />
        ) : null}
        <div id="webengage_webP_recommendation"></div>
      </section>

      {addRate && product ? (
        <AddNewRate {...{ setAddRate, t, product }} />
      ) : null}
      {showBranches ? (
        <AllBranches {...{ setShowBranches, branches: store, city }} />
      ) : null}
    </>
  );
};

export default ProductDetailsPage;

export async function getServerSideProps({
  locale,
  params: { rewrite_url },
  req,
  res,
}) {
  const parsedSku = rewrite_url.slice(rewrite_url?.lastIndexOf("-p-") + 3);
  const sku = parsedSku.includes("-")
    ? parsedSku.slice(0, parsedSku.indexOf("-"))
    : parsedSku;

  const handshake =
    req.cookies[handshakeCookieName(locale)] ||
    (await localeHandShake(locale, { req, res }))?.data?.token;
  const product = IS_TYPESENSE_GLOBAL
    ? await tssGetProductBySkuWithPreset(sku, locale)
    : await getProductBySku(sku, handshake);
  const pdp_details = await getActivePdpDetails(handshake);
  const productPath = product?.data ? product?.data?.[0]?._source : {};
  if (!productPath?.sku) {
    return {
      notFound: true,
    };
  }

  const product_data = {
    ...productPath,
    stock: {
      is_in_stock: productPath["1101"]?.value > 0,
      qty: productPath["1101"]?.value || 0,
    },
  };

  return {
    props: {
      product: product_data,
      pdp_details: pdp_details?.data?.data || null,
      ...(await serverSideTranslations(locale, ["common", "product"])),
    },
  };
}
